import { ModalService } from './../../../services/modal.service';
import {
  Component,
  OnInit,
  TemplateRef,
  ViewEncapsulation,
  Input,
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalType } from '../../../models/modal.type.enum';

@Component({
  selector: 'app-delete-respondent',
  templateUrl: './delete-respondent.component.html',
  styleUrls: ['./delete-respondent.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DeleteRespondentComponent implements OnInit {
  @Input() processDurationAppraiseeId: number;
  @Input() respondentId: number;
  @Input() appraiseeId?: number;
  @Input() allowSelfAssesment: boolean;

  modalRef: BsModalRef;
  isDeleteModalHidden: boolean;
  constructor(
    private bsModalService: BsModalService,
    public modalService: ModalService
  ) {
    this.hideModalSubscriber();
  }

  ngOnInit() {}

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.bsModalService.show(template);
  }

  changeModalBehaviour() {
    this.isDeleteModalHidden = !this.isDeleteModalHidden;
    this.modalService.changeModalVisibility(this.isDeleteModalHidden);
  }

  onOkClicked() {
    this.modalService.acceptModal({
      modalType: ModalType.Delete,
      processDurationAppraiseeId: this.processDurationAppraiseeId,
      respondentId: this.respondentId,
    });
  }

  getIsHideDeleteButton(): boolean {
    return this.appraiseeId === this.respondentId && this.allowSelfAssesment;
  }

  hideModal() {
    if (!this.modalRef) {
      return;
    }
    this.modalRef.hide();
  }

  private hideModalSubscriber() {
    this.modalService.hideModal$.subscribe((x) => this.hideModal());
  }
}
